import {ChangeDetectorRef, Component, OnInit, ViewChild} from "@angular/core";
import {AbstractVisbosComponent} from "../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../shared/actions/session.actions";
import {StockService} from "../../../store-management/services/stock.service";
import {Stock} from "../../../shared/view-model/stock";
import {FormControl} from "@angular/forms";
import {SearchInputComponent} from "../../../core/visbos-core/ui/navigation/search-input/search-input.component";
import {StockItemService} from "../../../store-management/services/stock-item-service/stock-item.service";
import {map, switchMap} from "rxjs/operators";

@Component({
  selector: 'vb-touch-depot-yard-search',
  templateUrl: './touch-depot-yard-search.component.html',
  styleUrls: ['./touch-depot-yard-search.component.css']
})
export class TouchDepotYardSearchComponent extends AbstractVisbosComponent implements OnInit {

  allowedTypes = ['Stock'];
  searchForm: FormControl;

  @ViewChild(SearchInputComponent)
  searchInput: SearchInputComponent;

  searchFunction = (term) => this.stockService.searchStocks(term)
    .pipe(map(({stocks}) => {
      let st = [...stocks];
      return st.sort((st1: Stock, st2: Stock) => st1.label.localeCompare(st2.label));
    }));

  stocks: Stock[] = [].sort();

  constructor(sessionActions: SessionActions, private stockService: StockService, private siService: StockItemService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit() {
    super.ngOnInit();
    this.searchForm = new FormControl();
  }

  barcodeFound(article: Stock) {
    if (article) {
      this.addSubscription(this.stockService.getStock(article.cuid).pipe(
        switchMap((st: any) => {
          return this.siService.getStockItem(st.stock_item.cuid);
        })
      )
        .subscribe((res: any) => {
          this.stocks = res.stocks;
        }));
    }
  }

  stocksFound(result: Stock[]) {
    this.stocks = result;
  }

  searchCleared() {
    this.stocks = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-depot-yard-search/touch-depot-yard-search.component.ts